import ActionFactory from './base/action-factory';
import PlayAudio from "./audio/play-audio";
import LoadViewpoint from "./viewpoint/load-viewpoint";
import VRInformation from "./misc/vr-information";
import ModelSelect from "./model/model-select";
import MoveVolume from "./model/move-volume";
import ExplodeModel from "./model/explode-model";
import ExplodeScene from "./model/explode-scene";
import MoveModel from "./model/move-model";
import MoveBranch from "./model/move-branch";
import MoveGroup from "./model/move-group";
import SceneTransformation from "./scene/sceneTransformation";
import AlignWithPhysical from './scene/align-with-physical';
import SelectOneOption from "./misc/select-one-option";
import CommandAction from "./misc/command-action";
import MediaScreenPlay from "./mediaScreen/mediaScreen-play";
import MediaScreenShow from "./mediaScreen/mediaScreen-show";
import MediaScreenChangePage from "./mediaScreen/mediaScreen-change-page";
import MediaScreenFocus from "./mediaScreen/mediaScreen-focus";
import MediaScreenCurrentTime from "./mediaScreen/mediaScreen-currentTime";
import MediaScreenSelect from "./mediaScreen/mediaScreen-select";
import VolumeSelect from "./model/volume-select";
import BranchSelect from "./model/branch-select";
import GroupSelect from "./model/group-select";
import UpdateMenuAction from "./menu/update-menu-action";
import GlbAnimation from "./model/glbAnimation";
import PlayAnimation from "./animation/playAnimation";
import PauseAnimation from "./animation/pauseAnimation";
import StopAnimation from "./animation/stopAnimation";
import Highlight from "./model/highlight";
import Transparency from "./model/transparency";
import Visibility from "./model/visibility";
import TextScript from "./misc/text-script";
import MeetingConfigurations from "./meeting-configurations/meetingConfiguration";
import ResetModel from "./model/reset-model";
import WorkspaceTermination from "./misc/workspace-termination";
import TextInput from "./misc/text-input";
import Wayfinding from "./wayfinding/wayfinding";
import ExternalSignalReceiver from "./externalSignalReceiver/externalSignalReceiver";
import ObjectProximityTrigger from "./model/object-proximity-trigger";
import StepInstructionMenu from "./misc/step-instruction-menu";
import Flash from "./model/flash";
import {ActionTypeEnum} from "./base/training-literals";
import TrackTime from "./misc/track-time";
import GetTimeDuration from "./misc/get-time-duration";
import UserActionMoveObjects from "./model/userAction-MoveObjects";
import AddMenu from "./menu/add-menu";

ActionFactory.register('PlayAudio', PlayAudio);
ActionFactory.register('LoadViewpoint', LoadViewpoint);
ActionFactory.register('VRInformation', VRInformation);
ActionFactory.register('ModelSelect', ModelSelect);
ActionFactory.register('MoveVolume', MoveVolume);
ActionFactory.register('MoveModel', MoveModel);
ActionFactory.register('MoveBranch', MoveBranch);
ActionFactory.register('MoveGroup', MoveGroup);
ActionFactory.register('ExplodeModel', ExplodeModel);
ActionFactory.register('ExplodeScene', ExplodeScene);
ActionFactory.register('SceneTransformation', SceneTransformation);
ActionFactory.register('AlignWithPhysical', AlignWithPhysical);
ActionFactory.register('SelectOneOption', SelectOneOption);
ActionFactory.register('CommandAction', CommandAction);
ActionFactory.register('MediaScreenPlay', MediaScreenPlay);
ActionFactory.register('MediaScreenShow', MediaScreenShow);
ActionFactory.register('MediaScreenChangePage', MediaScreenChangePage);
ActionFactory.register('MediaScreenFocus', MediaScreenFocus);
ActionFactory.register('MediaScreenCurrentTime', MediaScreenCurrentTime);
ActionFactory.register('MediaScreenSelect', MediaScreenSelect);
ActionFactory.register('VolumeSelect', VolumeSelect);
ActionFactory.register('UpdateMenuAction', UpdateMenuAction);
ActionFactory.register('UserActionMoveObjects', UserActionMoveObjects);
ActionFactory.register('GlbAnimation', GlbAnimation);
ActionFactory.register('PlayAnimation', PlayAnimation);
ActionFactory.register('PauseAnimation', PauseAnimation);
ActionFactory.register('StopAnimation', StopAnimation);
ActionFactory.register('Highlight', Highlight);
ActionFactory.register('Transparency', Transparency);
ActionFactory.register('Visibility', Visibility);
ActionFactory.register('TextScript', TextScript);
ActionFactory.registerSpecial('TextScript', 'External-Signal-Receiver', ExternalSignalReceiver);
ActionFactory.register('MeetingConfigurations', MeetingConfigurations);
ActionFactory.register('ResetModel', ResetModel);
ActionFactory.register('WorkspaceTermination', WorkspaceTermination);
ActionFactory.register('TextInput', TextInput);
ActionFactory.register('Wayfinding', Wayfinding);
ActionFactory.register('ObjectProximityTrigger', ObjectProximityTrigger);
ActionFactory.register('StepInstructionMenu', StepInstructionMenu);
ActionFactory.register('Flash', Flash);
ActionFactory.register(ActionTypeEnum.TRACK_TIME, TrackTime);
ActionFactory.register(ActionTypeEnum.GET_TIME_DURATION, GetTimeDuration);
ActionFactory.register(ActionTypeEnum.BRANCH_SELECT, BranchSelect);
ActionFactory.register(ActionTypeEnum.GROUP_SELECT, GroupSelect);
ActionFactory.register(ActionTypeEnum.ADD_MENU, AddMenu);


